import { render, staticRenderFns } from "./Vencimiento.vue?vue&type=template&id=3c131b6a&"
import script from "./Vencimiento.vue?vue&type=script&lang=js&"
export * from "./Vencimiento.vue?vue&type=script&lang=js&"
import style0 from "./Vencimiento.vue?vue&type=style&index=0&id=3c131b6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports